import { render, staticRenderFns } from "./MenuIcon.vue?vue&type=template&id=ef193e06&scoped=true"
import script from "./MenuIcon.vue?vue&type=script&lang=js"
export * from "./MenuIcon.vue?vue&type=script&lang=js"
import style0 from "./MenuIcon.vue?vue&type=style&index=0&id=ef193e06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef193e06",
  null
  
)

export default component.exports